// Module
var code = `<div class="page-content">

  <section class="page-heading">

  </section>


  <section class="page-body default-content">


  </section>


</div>
`;
// Exports
module.exports = code;